import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { LayoutService } from '../../../@vex/services/layout.service';
import { filter, map, startWith } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { checkRouterChildsData } from '../../../@vex/utils/check-router-childs-data';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ConfigService } from '../../../@vex/config/config.service';
import { UntilDestroy } from '@ngneat/until-destroy';


@UntilDestroy()
@Component({
  selector: 'app-exhibition-layout',
  templateUrl: './app-exhibition-layout.component.html'
})
export class AppExhibitionLayoutComponent implements OnInit, OnDestroy {
  sidenavCollapsed$ = this.layoutService.sidenavCollapsed$;
  isDesktop$ = this.layoutService.isDesktop$;

  toolbarShadowEnabled$ = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    startWith(null),
    map(() => checkRouterChildsData(this.router.routerState.root.snapshot, data => data.toolbarShadowEnabled))
  );

  constructor(private layoutService: LayoutService,
              private configService: ConfigService,
              private router: Router) { }

  ngOnInit() {
    this.configService.updateConfig({
      toolbar: {
        fixed: true,
      },
      sidenav: {
        state: 'collapsed'
      }
    });

  }

  ngOnDestroy() {
    this.configService.updateConfig({
      toolbar: {
        fixed: true,
      },
      sidenav: {
        state: 'expanded'
      }
    });
  }

}
